import React, { Component } from "react";
import { connect } from "react-redux";
import { mapKV } from "../utils/map";
import { SelectInput } from "../components/SelectInput";
import { isCurrentUserSuperAdmin } from "../utils/userRoles";

export class SelectOrganization extends Component {
  render() {
    const { organizations, value, onChange } = this.props;

    const options = [];
    mapKV(organizations, (key, org) =>
      options.push({ value: key, label: org.name })
    );

    return (
      <div>
        {isCurrentUserSuperAdmin() && (
          <SelectInput
            required
            label="Organization"
            value={value}
            options={options}
            onChange={onChange}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({ organizations: state.data.organizations });

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectOrganization);
